import React, { useState, useEffect } from "react";
import useModal from "../../hooks/useModal";
import HelpService from './HelpService';
import useStyle from '../../hooks/useStyle';
import FilterSlider from "../Common/FilterSlider";
import { PlannerVideoPlayer } from '../Common/VideoPlayer';
import { DivRichTextView } from "../Common/RichTextView";
import { useCurrentUserHook } from "../Authentication/useUserHook";
import { NavIcon } from "../Common/MenuItem";
import { Spinner } from "../Common/Spinner";
import { FilterAccordionPanel } from "../Common/AccordionPanel";

const HelpSidePanel = (props) => {
  useStyle('help');

  const {currentUser} = useCurrentUserHook();
  const [loading, setLoading] = useState(true);
  const [helps, setHelps] = useState([]);

  useEffect(() => {
    if(props.recordIds || props.tagIds){
      getHelp();   
    }else{
      console.error("No Help id passed");
    }
  }, [])

  let getHelp = () => { 
    setLoading(true);

    let tags = [];
    if(props.tagIds) tags.push(props.tagIds);

    let req = {
      'page':1,
      'per_page':10,
      'parent_ids': props.recordIds, 
      'tag_ids': tags,
      'sort_column': 'data.order_id',
      'sort_direction': 'asc'
    }

    if(props.filterByOrg){
      req.filter = {
        'assigned_to_organization_id': currentUser.current_organization_id
      }
    }

    HelpService.getAll(req).then((res) => {
      if(res.status === 200){
        setHelps(res.data.helps || []);
        setLoading(false);
        
        if(res.data.helps?.length > 0){
          props.setTitle && props.setTitle(res.data.helps[0].data?.title || "Info");
        }
      }
    })
  }

  return(
    <div id="ct" className="p-l-15 p-r-10 z-idx-99">
      {loading ?
        <Spinner/>
        :  
        <>
          {helps.map((h, i) => (
            <FilterAccordionPanel
              key={i}
              title={h.data?.title || `Info ${i + 1}`}
              count={0}
              isOpen={helps.length === 1}>
              <div className="ht-500 scroll-x p-5">
                <HelpDetails h={h}/>
              </div>
            </FilterAccordionPanel>
          ))}
        </>
      }
    </div>      
  )
}

const HelpDetails = ({h, is}) => {
  const { isOpen:playVideo, toggleModal:togglePlayVideo } = useModal();

  if(h.data.video_url){
    const params = new URL(h.data.video_url).searchParams;
    h.data.img_url = `https://img.youtube.com/vi/${params.get('v')}/mqdefault.jpg`;
  }

  return(
    <>
      <DivRichTextView id="help_img" html={(h.privacy_type==='public' ? h.data?.public_details : h.data?.details)}/>
      {h.data.video_url ?
        <>
          <div className="border-dashed-sm play-btn p5" onClick={()=>togglePlayVideo()}>
            <img src={h.data.img_url} className="img-thumbnail img-rounded img-responsive center-block"/>
          </div>
          {playVideo ? <PlannerVideoPlayer url={h.data.video_url} toggleModal={togglePlayVideo}/> : null}
        </>
        : null
      }
    </>
  )
}

const HelpIcon = (props) => {
  const {recordIds, tagIds, className, iconClassName, showBtn} = props;

  const [title, setTitle] = useState("Info");
  const { isOpen:isPanelOpen, toggleModal:togglePanel } = useModal();

  if(!(recordIds || tagIds)) return null;

  return(
    <>
      {showBtn ?
        <NavIcon
          id="help"
          dataTip="Info"
          positionCss="left"
          onSelect={() => togglePanel()}
          className={"bg-highlight round-btn float-right m-l-15 " + (className || '')}
          icon="fa-regular fa-info-circle"/>
        :
        <span data-tip="Help" className={className || 'm-l-15 f18'} onClick={()=>togglePanel()}>
          <i className={iconClassName || "fa-regular fa-info-circle f20 bold text-blue"}/>
        </span>
      }
      {isPanelOpen &&
        <FilterSlider
          title={title}
          component1={(props) => <HelpSidePanel {...props} setTitle={setTitle}/>}
          openSideNav={isPanelOpen}
          setOpenSideNav={togglePanel}
          allowExpand={true}
          {...props}/>
      }
    </>
  )
}

export {HelpIcon, HelpDetails};